/**
 * 从营期列表 + URL 传入的 qs 解析当前选中的营期 qs。
 * 仅当 URL 携带的 qs 能命中列表某项时返回该 qs;否则返回 null(不默认选择)。
 * @param {Array<{qs:Number, regionStatus:String}>} campOptions
 * @param {string|undefined} urlQs  URL query 里的 qs(可能是 string)
 * @returns {Number|null}
 */
function resolveCurrentQs(campOptions, urlQs) {
  const intQs = urlQs != null && urlQs !== '' ? parseInt(urlQs, 10) : NaN;
  if (!Number.isNaN(intQs)) {
    const hit = campOptions.find(function (o) { return o.qs === intQs; });
    if (hit) { return hit.qs; }
  }
  return null;
}

module.exports = { resolveCurrentQs };